import React from "react";
import PropTypes from "prop-types";
import TTLProxy from "../../common/TTLAsyncProxy";
import {TractorOperatorEndpoint} from "../../common/ProxyEndpoints";
import TimeAgo from "../../common/TimeAgo";
import {Badge, Button, ButtonGroup, UncontrolledTooltip} from "reactstrap";
import Utils, {containsText} from "../../common/Utils";
import SmartDialog from "../../components/SmartDialog";
import DataList from "../../components/TableListView/DataList";
import {Gender} from "../../common/Constants";
import FormRenderer from "../../common/FormRenderer";
import {getInputs as GetInputs} from "./OperatorCommon";
import HTML from "../../common/HtmlHelpers";
import LoadingView from "../../components/Elements/LoadingView";
import {ChannelSubscription} from "../../common/UserNotifications/Subscriptions";
import NotificationChannels from "../../common/NotificationChannels";
import EventListener from "../../common/EventListener";
import EventActions from "../../common/Events/Actions";

export class OperatorRegistrationDialog extends React.Component {

    static propTypes = {
        tractors: PropTypes.array,
        owners: PropTypes.array,
        fetchOwnerTractors: PropTypes.func,
        fetchTractorOwners: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = OperatorRegistrationDialog.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState() {

        return {
            isBusy: false,
            operators: null,
            operatorsFiltered: null,
            search: ""
        };

    }

    _filterOperators(operators, search) {
        return search ? operators.filter(x => containsText(x.name, search) || containsText(x.phone, search) || containsText(x.location, search)) : operators;
    }

    loadState(showProgress = true) {

        const proxy = this.proxy;

        this.setState({
            isBusy: showProgress
        });

        return proxy.processRequest({
            ...TractorOperatorEndpoint.getUSSDRegistered(),
            sort: ['-date_created']
        }).then(response => {

            const data = response.getPayload();

            this.setState({
                operators: data,
                operatorsFiltered: this._filterOperators(data, this.state.search),
                isBusy: false
            }, () => this._list.refresh());

        }).catch(err => {

            //  Toast response error
            HTML.toastError(Utils.getResponseError(err));

            this.setState({
                isBusy: false
            });

        });
    }

    show() {

        //
        this.setState(OperatorRegistrationDialog.getInitialState(), () => {

            //  load required state
            this.loadState();

            //  show dialog
            this._dlg.show();

        });


    }

    render() {

        const state = this.state;
        const operators = state.operators || [];
        const columns = [
            {
                key: "name",
                label: "Name"
            },
            {
                key: "phone",
                label: "Phone"
            },
            {
                key: "location",
                label: "Location"
            },
            {
                label: "Time Sent",
                render: item => <TimeAgo date={item.date_created} id={`time_sent_${item.id}`}/>
            },
            {
                label: "Status",
                render: item => item.date_checked === null ? "Not Registered" :
                    <React.Fragment>
                        <h6 id={`status_item_${item.id}`}>
                            <Badge pill color="success"><i className="fa fa-check"/> Registered</Badge>
                        </h6>
                        <UncontrolledTooltip target={`status_item_${item.id}`} placement={"bottom"}
                                             fade={false}>{Utils.formatDateLong(item.date_checked)}</UncontrolledTooltip>
                    </React.Fragment>

            }
        ];

        return <SmartDialog ref={r => this._dlg = r} title={"Operator Requests (USSD)"} large={true}>

            <EventListener events={EventActions.OperatorRequestUpdate} onEvent={() => this.loadState(false)}/>

            <div>

                <div className="clearfix" style={{marginBottom: 10}}>
                    <div className="pull-left">
                        <h6><Badge pill={true}>Total: {operators.length}</Badge></h6>
                    </div>
                    <div className="pull-right">
                        <ButtonGroup>
                            <Button outline={true} color={"primary"} size={"sm"} style={{borderRadius: 5}}
                                    onClick={() => this.loadState()}><i className="fa fa-refresh"></i> Refresh</Button>
                        </ButtonGroup>
                    </div>
                </div>

                <input style={{width: "100%", marginBottom: 10}}
                       onChange={evt => {

                           const search = evt.target.value;

                           this.setState({
                               search,
                               operatorsFiltered: this._filterOperators(this.state.operators, search)
                           }, () => this._list.refresh());

                       }} type="text" className="form-control form-input" placeholder="Search operators here..."/>


                <LoadingView isBusy={state.isBusy} message={"Please hold on...."}>

                    <DataList itemsPerPage={5}
                          columns={columns}
                          responsive
                          listRef={r => this._list = r}
                          rowActions={[
                              {
                                  label: "Register",
                                  icon: <i className="fa fa-plus"/>,
                                  disabled: item => item.date_checked !== null,
                                  onClick: (operator) => {

                                      this.setState({
                                          contextOperator: operator
                                      }, () => {

                                          this._registerDlg.show();

                                          //
                                          window.setTimeout(() => {

                                              //  bind details of operator
                                              const formRenderer = this._form;
                                              if (formRenderer) {

                                                  formRenderer.bindItem({
                                                      name: operator.name,
                                                      address: operator.location,
                                                      phone: operator.phone,
                                                      license: "",
                                                      sex: Gender.Male
                                                  });

                                              }

                                          }, 410);

                                      });

                                  }
                              }
                          ]}
                          noRowsMessage={"No operator/driver requests have been made!"}
                          data={this.state.operatorsFiltered}/>

                </LoadingView>

                <SmartDialog title={"Register Tractor Operator"}
                             ref={r => this._registerDlg = r}>

                    <FormRenderer inputs={GetInputs({
                                        editItem: null,
                                        owners: this.props.owners,
                                        tractors: this.props.tractors,
                                        fetchOwnerTractors: this.props.fetchOwnerTractors,
                                        refreshTractorOwners: this.props.fetchTractorOwners,
                                        formRenderer: () => this._form
                                  })}
                                  ref={r => this._form = r}
                                  onSubmit={async payload => {

                                      try {

                                          let res = await this.proxy.processRequest(TractorOperatorEndpoint.createOperator(payload.owner, payload.tractor, {
                                              name: payload.name,
                                              phone: payload.phone,
                                              address: payload.address,
                                              address_lat: payload.address_lat,
                                              address_long: payload.address_long,
                                              license: payload.license,
                                              sex: payload.sex
                                          }));

                                          if (res.ok) {

                                              //
                                              HTML.toastSuccess('Registration completed successfully');

                                              //    check registration
                                              const { contextOperator } = this.state;

                                              try{

                                                  res = await this.proxy.processRequest(TractorOperatorEndpoint.checkOperatorRequest(contextOperator.id));
                                                  if(res.ok){
                                                      //   operator request checked
                                                  }

                                              }
                                              catch (e) {
                                                  // Failed checking request
                                              }


                                              //    toggle dialog
                                              this._registerDlg.hide();

                                              //
                                              return this.loadState();
                                          }

                                      } catch (e) {
                                          HTML.toastError(Utils.getResponseError(e));
                                      }

                                  }}>

                        <hr/>

                        <Button color="green" block><i className="fa fa-plus"/> Register Operator</Button>

                    </FormRenderer>

                </SmartDialog>



            </div>
        </SmartDialog>
    }
}


// WEBPACK FOOTER //
// ./src/views/Operators/OperatorRequests.js